import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

export default function CardSemental({ animal }) {
    const { t } = useTranslation()

    return (
        <>
            <Row className="mb-3">
                <Col xs={12} md={4}><strong>{t('card.ID')}:</strong> {animal.identifier}</Col>
                <Col xs={12} md={4}><strong>{t('card.lot')}:</strong> {animal?.lot?.identifier}</Col>
                <Col xs={12} md={4}><strong>{t('card.zone')}:</strong> {animal?.lot?.zone?.name}</Col>
            </Row>
            <hr/>
            <Row className="mb-3">
                <Col xs={12} md={4}><strong>{t('card.age')}:</strong> {animal.birthDate ? `${new Date().getFullYear() - new Date(animal.birthDate).getFullYear()} ${t('card.yearsAnd')} ${new Date().getMonth() - new Date(animal.birthDate).getMonth()} ${t('card.months')}` : '—'}</Col>
                <Col xs={12} md={4}><strong>{t('card.isActive')}:</strong> {animal.active ? t('card.active') : t('card.desvieje')}</Col>
                <Col xs={12} md={4}><strong>{t('card.productiveStatus')}:</strong> {t('admin.animal.productive_status_'+animal?.productiveStatus)}</Col>
            </Row>
            <hr/>
            <Row className="mb-3">
                <Col xs={12} md={4}><strong>{t('card.breed')}:</strong> {t('admin.animal.breed_'+animal?.breed)}</Col>
                <Col xs={12} md={4}><strong>{t('card.father')}:</strong> {animal?.father?.identifier || '—'}</Col>
                <Col xs={12} md={4}><strong>{t('card.mother')}:</strong> {animal?.mother?.identifier || '—'}</Col>
            </Row>
            <hr/>
            <Row className="mb-3">
                <Col xs={12} md={6}><strong>{t('card.origin')}:</strong> {animal.origin || '—'}</Col>
                <Col xs={12} md={6}><strong>{t('card.notes')}:</strong> {animal.notes || '—'}</Col>
            </Row>
        </>
    )
}
